import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=30cd28a1&scoped=true&"
import script from "./templateSelect.vue?vue&type=script&lang=js&"
export * from "./templateSelect.vue?vue&type=script&lang=js&"
import style0 from "./templateSelect.vue?vue&type=style&index=0&id=30cd28a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd28a1",
  null
  
)

export default component.exports